<template>
  <button class="switch-edit-mode-button-parts" @click="emitClick">
    <img
      :src="
        type === 'edit'
          ? require('@/assets/img/icon/icon_edit.svg')
          : require('@/assets/img/icon/icon_close_white_18.svg')
      "
      width="18"
      height="18"
      alt=""
    />
  </button>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'

type SwitchType = 'edit' | 'cancel'

/**
 * マイページ: 会員証 編集切り替えボタン
 */
export default defineComponent({
  name: 'SwitchEditModeButtonParts',
  props: {
    type: {
      type: String as PropType<SwitchType>,
      required: true,
    },
  },
  methods: {
    /**
     * 編集キャンセル通知
     */
    async emitClick() {
      this.$emit('click')
    },
  },
})
</script>

<style lang="scss" scoped>
.switch-edit-mode-button-parts {
  position: absolute;
  left: min(#{convertPXtoVW(10)}, 10px);
  top: min(#{convertPXtoVW(10)}, 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(#{convertPXtoVW(32)}, 32px);
  height: min(#{convertPXtoVW(32)}, 32px);
  background: $black;
  border-radius: 50%;
  cursor: pointer;

  img {
    width: min(#{convertPXtoVW(18)}, 18px);
  }
}
</style>
